// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__bQ7L6","selects":"Documents_selects__12llk"};